import { Component, ViewChild, Input, inject } from '@angular/core';
import { loadMessages, locale } from 'devextreme/localization';
import RELocalization from 'src/assets/translations/dx-rich.fr.json';
import { IRicheditComponent } from '@devinforius/i-dx-editor';
import { ConfigService } from 'src/app/shared/services/config.service';
import { DocumentFormatApi } from 'devexpress-richedit/lib/model-api/formats/enum';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';
import { DocumentsService } from 'src/app/shared/services/documents.service';
import { toMergeFieldsForEditor } from 'src/app/shared/utils/merge-fields-for-editor.util';
@Component({
  selector: 'app-reader',
  templateUrl: './reader.component.html',
  styleUrls: ['./reader.component.scss'],
})
export class RichEditReaderComponent {
  private readonly documentsService = inject(DocumentsService)
  public readonly mergeFields = toSignal(this.documentsService.getFusionsField().pipe(map(toMergeFieldsForEditor)), { initialValue: {} });

  file: File;
  public baseUrlDocumentEditor: string;
  public show = false;
  @ViewChild('document_editor') public editor: IRicheditComponent;
  @Input() set currentFile(value) {
    this.file = null;

    if (value !== undefined) {
      this.file = value;
      setTimeout(() => {
        this.loadFile(value);
      }, 2000);
    }
  }
  @Input() allowPrint;
  @Input() allowDownload;
  public lang = localStorage.getItem('lang');

  constructor(private config: ConfigService) {
    this.baseUrlDocumentEditor = config['baseUrlDocumentEditor'];
    if (RELocalization) {
      loadMessages({ fr: RELocalization });
      locale('fr');
    }
  }

  onCreated(): void {
    if (this.file) {
      this.loadFile(this.file);
    }
  }

  private getDocumentFormat(fileName: string): DocumentFormatApi {
    const extension = fileName.split('.').pop()?.toLowerCase();
    if (extension === 'docx') {
      return DocumentFormatApi.OpenXml;
    }
    return DocumentFormatApi.Rtf;
  }

  public loadFile(file: File): void {
    this.editor?.rich.openDocument(file, 'document', this.getDocumentFormat(file.name), () => {
      this.show = true;
    });
  }
}
